














































import {
  Component, Emit, Prop, Ref, Vue,
} from 'vue-property-decorator';
import {
  filter, find, isFinite, map, sum,
} from 'lodash';
import VueMultiselect from 'vue-multiselect';
import PaymentOrderTransaction from '@/components/PaymentOrderTransaction.vue';
import TransactionParticipant from '@/models/TransactionParticipant';
import clickaway from '@/directives/clickaway';
import TransactionDto from '@/interfaces/transaction.dto';
import ScanField from '@/components/ScanField.vue';
import { formatMoney } from '@/utils/format';
import BankSlip from '@/components/BankSlip.vue';
import { Transaction, TransactionGroup } from '@/api/payment-orders';

@Component({
  name: 'PaymentOrderGroup',
  components: {
    BankSlip,
    PaymentOrderTransaction,
    VueMultiselect,
    ScanField,
  },
  directives: {
    clickaway,
  },
})
export default class PaymentOrderGroup extends Vue {
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly debtors!: TransactionParticipant[];

  @Prop({
    type: Array,
    default: () => [],
  })
  readonly creditors!: TransactionParticipant[];

  @Prop({
    type: Object,
    required: true,
  })
  readonly group!: TransactionGroup;

  @Prop({
    type: Boolean,
  })
  readonly isModalOpen!: boolean;

  @Ref('bankSlip') readonly bankSlip!: BankSlip;

  editingTransactionId: string | null = null;

  get editingTransaction() {
    return find(this.group.transactions, ['id', this.editingTransactionId]) || null;
  }

  get transactions() {
    return this.group.transactions;
  }

  get numberOfTransactions() {
    return this.group.transactions.length;
  }

  get controlSum() {
    return sum(filter(map(this.group.transactions, 'amount'), isFinite));
  }

  get controlSumFormatted() {
    return formatMoney(this.controlSum);
  }

  onTransactionSubmit(transaction: Transaction, transactionId?: string) {
    if (transactionId) {
      Object.assign(this.editingTransaction, transaction);

      this.editingTransactionId = null;

      return;
    }
    this.group.transactions.push(transaction);

    this.bankSlip.reset();
    this.onElementAdd();
    this.bankSlip.scanModeOn();
  }

  @Emit('transaction:scan')
  onTransactionScan(transactionDto: TransactionDto | null) {
    if (!transactionDto) {
      return null;
    }

    return { ...transactionDto, dbtrAddr: this.group.debtor.name };
  }

  onTransactionEdit(transactionId: string) {
    this.editingTransactionId = transactionId;
  }

  onTransactionDelete(transactionId: string) {
    this.group.transactions = this.transactions.filter(({ id }) => id !== transactionId);

    if (!this.group.transactions.length) {
      this.$emit('group:delete');
    }
  }

  onBankSlipCancel() {
    this.editingTransactionId = null;

    if (!this.group.transactions.length) {
      this.$emit('group:delete');
    }
  }

  @Emit('element:add')
  onElementAdd() {
    return true;
  }
}
